// useCreateJobGroup (issue #419) — POST /chats/jobs/:jobId/group.
//
// Idempotent on the server side — calling repeatedly returns the existing
// JOB_GROUP chat for the job's parent shift, never creating duplicates.

import { useMutation, useQueryClient } from '@tanstack/react-query';

import { createJobGroup } from './api';
import { chatKeys } from './keys';

import type { Chat } from 'src/models/chat';

export function useCreateJobGroup() {
  const queryClient = useQueryClient();
  return useMutation<Chat, unknown, { jobId: number }>(
    ({ jobId }) => createJobGroup(jobId),
    {
      onSuccess: (_chat, { jobId }) => {
        queryClient.invalidateQueries(chatKeys.myChatsRoot());
        queryClient.invalidateQueries(chatKeys.jobChats(jobId));
      },
    }
  );
}
